import React,{useState, useRef, useEffect, forwardRef, useImperativeHandle} from 'react';
import {Link} from "react-router-dom";
import CloudPath from "../../../cloud/cloud_path";
import {Button, Input, Select} from "antd";
import CloudApi from "../../../cloud/cloud_api";
import SingleContent from "./singleContent";
import spin from "../../../cloud/customer/material/image/spin.gif";
// import noSearch from "../../../cloud/customer/material/image/noSearch.png";
import noVerbalTrick from "../../../cloud/customer/material/image/noVerbalTrick.png"
let timer = null
let pageNum = 1
let pages = null
const {Option} = Select
const WordsArtLibrary = forwardRef((props,ref) =>{
    const [wordsArtLibrary, setWordsArtLibrary] = useState([])//话术库列表
    const [chatCustomer, setChatCustomer] = useState(false)//搜索的焦点事件
    const [content, setContent] = useState('')//搜索的参数
    const [groupId, setGroupId] = useState(9)//搜索的参数
    const [groupList, setGroupList] = useState([])//话术分组的列表
    const [chatData, setChatData] = useState({})//左侧联系人的数据消息
    const singleContentRef = useRef(null)
    useEffect(()=>{
        setChatData(props.chatData)
    },[props.chatData])
    useEffect(()=>{
        //获取右侧的话术分组列表
        CloudApi.getChatLibGroupList((data)=>{
            if(data.list){
                data.list.forEach((item)=>{
                    if(item.groupId == 9){
                        item.groupName = '全部分组'
                    }
                })
            }
            setGroupList(data.list)
        },()=>{})
        let bodyData={
            content:content,
            orderby:null,
            groupId:groupId
        }
        //获取话术内容
        CloudApi.getChatLibContentList(1,20,bodyData,(data)=>{
            data.list.forEach((item)=>{
                item.flag = false
            })
            setWordsArtLibrary(data.list)
        })
    },[])
    useEffect(()=>{
        pageNum=1
    },[props.chat_wxid])

    useEffect(()=>{
        document.querySelector('.words_art_library_content') && document.querySelector('.words_art_library_content') .addEventListener('scroll', handleScroll.bind(this))
    },[wordsArtLibrary])

    //滚动事件
    function handleScroll() {
        const contentScrollTop = document.querySelector('.words_art_library_content').scrollTop
        const clientHeight = document.querySelector('.words_art_library_content').clientHeight
        const scrollHeight = document.querySelector('.words_art_library_content').scrollHeight
        clearTimeout(timer)
        if(scrollHeight - (contentScrollTop + clientHeight)<=150){
            timer = setTimeout(()=>{
                let bodyData={
                    content:'',
                    orderby:null,
                    groupId:groupId
                }
                pageNum = pageNum+1
                //获取话术内容
                CloudApi.getChatLibContentList(pageNum,20,bodyData,(data)=>{
                    data.list.forEach((item)=>{
                        item.flag = false
                    })
                    pages = data.pagInfo.pages
                    let newData = wordsArtLibrary.concat(data.list)
                    setWordsArtLibrary(newData)
                })
            },500)
        }
    }
    //获取焦点
    function chatCustomerFocus() {
        setChatCustomer(true)
    }

    //失去焦点
    function chatCustomerBlur() {
        setChatCustomer(false)
    }
    //搜索的事件
    function searchNameChange(e) {
        setContent(e.target.value)
        if(e.target.value == ''){
            let bodyData={
                content:'',
                orderby:null,
                groupId:groupId
            }
            //获取话术内容
            CloudApi.getChatLibContentList(1,20,bodyData,(data)=>{
                data.list.forEach((item)=>{
                    item.flag = false
                })
                pages = data.pagInfo.pages
                setWordsArtLibrary(data.list)
            })
        }
    }
    //回车事件
    function searchChange() {
        if(content != ''){
            let bodyData={
                content:content,
                orderby:null,
                groupId:groupId
            }
            //获取话术内容
            CloudApi.getChatLibContentList(1,20,bodyData,(data)=>{
                data.list.forEach((item)=>{
                    item.flag = false
                })
                pages = data.pagInfo.pages
                setWordsArtLibrary(data.list)
            })
        }
    }
    //点击切换下拉事件
    function groupIdChange(e) {
        setGroupId(e)
        let bodyData={
            content:content,
            orderby:null,
            groupId:e
        }
        //获取话术内容
        CloudApi.getChatLibContentList(1,20,bodyData,(data)=>{
            data.list.forEach((item)=>{
                item.flag = false
            })
            pages = data.pagInfo.pages
            setWordsArtLibrary(data.list)
        })
    }



    return (
        <div className={'words_art_library'}>
            {
                (pages == null && wordsArtLibrary.length == 0) ?
                    <div className={'did_come_in_initially'}>
                        <div className={'nothing_art'}>
                            <Link to={CloudPath.getCreateTalklib()}>
                                <Button type="primary" ghost>创建话术</Button>
                            </Link>
                        </div>
                    </div>
                     : (pages == 0 && wordsArtLibrary.length == 0) ? <div className={'is_words'}>
                        <div className={'search_words'}>
                            <Input placeholder={'搜索相关话术'}
                                   className={chatCustomer ? 'chat_customer_name' : 'have_background'}
                                   bordered={chatCustomer}
                                   onFocus={chatCustomerFocus}//获取焦点
                                   onBlur={chatCustomerBlur}//失去焦点
                                   value={content}
                                   onChange={searchNameChange}
                                   onPressEnter={searchChange}
                            />
                            <div>
                                {groupList.length > 0 ? <Select bordered={false} value={groupId} onChange={groupIdChange} dropdownClassName='a_drop_down_option'>
                                    {groupList.map((item,index)=>{
                                        return <Option key={index}
                                                       value={item.groupId}
                                        >
                                            {item.groupName}
                                        </Option>
                                    })}
                                </Select> : ''}
                            </div>
                        </div>
                        <div className={'words_art_library_content'}>
                            <div style={{width:'100%',height:'100%',background:'#FFFFFF'}}>
                                <img src={noVerbalTrick} className={'not_found'}/>
                            </div>
                        </div>
                    </div> :
                    <div className={'is_words'}>
                        <div className={'search_words'}>
                            <Input placeholder={'搜索相关话术'}
                                   className={chatCustomer ? 'chat_customer_name' : 'have_background'}
                                   bordered={chatCustomer}
                                   onFocus={chatCustomerFocus}//获取焦点
                                   onBlur={chatCustomerBlur}//失去焦点
                                   value={content}
                                   onChange={searchNameChange}
                                   onPressEnter={searchChange}
                            />
                            <div>
                                {groupList.length > 0 ? <Select bordered={false} value={groupId} onChange={groupIdChange} dropdownClassName='a_drop_down_option'>
                                    {groupList.map((item,index)=>{
                                        return <Option key={index}
                                                       value={item.groupId}
                                        >
                                            {item.groupName}
                                        </Option>
                                    })}
                                </Select> : ''}
                            </div>
                        </div>
                        <div className={'words_art_library_content'}>
                            {
                                wordsArtLibrary.map((item,index)=>{
                                    return <SingleContent
                                        ref={singleContentRef}
                                        title={item} //标题
                                        key={index}
                                        data={item.list} //卡片数据
                                        aFoldFlag={item.flag} //展开收起的开关
                                        chatData={chatData}
                                    />
                                })
                            }
                            {
                                pageNum == 1 ? <div style={{width:'100%',height:'19px'}}></div> :
                                    pageNum > 1 && (pageNum < pages) ?
                                        <div className={'loading'}><img src={spin}/>正在加载更多素材</div> :
                                        (pageNum > 0 && pageNum >= pages) ?
                                            <div className={'i_draw_line'}>——我是有底线的——</div> : <div style={{width:'100%',height:'19px'}}></div>
                            }
                        </div>
                    </div>
            }
        </div>
    );
})
export default WordsArtLibrary;